// extracted by mini-css-extract-plugin
module.exports = {"form":"src-_components-___UserEditForm-module__form___2kwYp"};